export const ADD_PROJECT = 'ADD_PROJECT';
export const PROJECTS = 'PROJECTS';
export const PROJECT = 'PROJECT';
export const DELETE = 'DELETE';
export const SORT = 'SORT';
export const MORE = 'MORE';
export const LOADING = 'LOADING';
export const TOTAL = 'TOTAL';
export const ADD_PENDING_PROGRESS = 'ADD_PENDING_PROGRESS';
export const REMOVE_PENDING_PROGRESS = 'REMOVE_PENDING_PROGRESS';
export const CLEAR_ITEMS = 'CLEAR_ITEMS';
export const SET_LOGS = 'SET_LOGS';
export const SET_LOGS_LOADING = 'SET_LOGS_LOADING';

export default {
  ADD_PROJECT,
  PROJECTS,
  PROJECT,
  DELETE,
  SORT,
  MORE,
  LOADING,
  TOTAL,
  ADD_PENDING_PROGRESS,
  REMOVE_PENDING_PROGRESS,
  CLEAR_ITEMS,
  SET_LOGS,
  SET_LOGS_LOADING,
};
